<template>
  <div class="c-aweme-action">
    <div class="c-aweme-line">
      <span>定向与以下达人产生</span>

      <el-cascader
        v-model="action_scene"
        :options="cascaderOptions"
        :props="{ multiple: true, emitPath: false, label: 'title' }"
        :show-all-levels="false"
        collapse-tags
        clearable
        style="width: 220px"
      ></el-cascader>

      <span>互动的用户，时间范围取</span>
      <Select v-model="action_days" style="width: 80px; margin: 0 6px">
        <Option v-for="day of days" :key="day.key" :value="day.key">{{ day.value }}</Option>
      </Select>
      <span v-if="!sceneLen" class="scene-error g-error-text">请选择至少一个互动行为</span>
    </div>
    <Row class-name="c-action-content">
      <Col span="16" class-name="c-action-category">
        <Tabs v-model="tagType" :animated="false">
          <TabPane label="添加达人分类" name="category">
            <category-select
              v-model="mult_category"
              :loading="loading"
              :data="categories"
              :words="words"
              :query-word="queryWord"
              :complete-data="autoData"
              :disabled="disabled"
              placeholder="支持搜索抖音达人、抖音昵称或抖音达人所在分类"
              @on-select="queryWord = $event"
              @on-search="searchKeyword"
              @on-complete="searchCategory"
              @on-cancel="cannelHandle"
              @on-add="selectKeyword"
            />
          </TabPane>
          <TabPane label="添加抖音达人" name="keyword">
            <keyword-select
              :author="author"
              :query-word="queryWord"
              :data="keywords"
              :words="words"
              :recommons="recommons"
              :complete-data="completeData"
              :loading="quering"
              :disabled="disabled"
              placeholder="全部抖音达人分类"
              @on-complete="searchKeyword"
              @on-select="selectKeyword"
              @on-search="queryKeyword"
              @on-clear="recommons = []"
            />
          </TabPane>
          <div slot="extra" v-show="false">
            <p :style="{ lineHeight: '50px', paddingRight: '10px', display: 'inline-block' }">使用账号：{{ userAccount }}</p>
          </div>
        </Tabs>
      </Col>
      <Col span="7" offset="1">
        <action-result :value="actions" :loading="loading" :max="max" sub-title @on-delete="delTag" @on-clear="clearTag" />
      </Col>
    </Row>
  </div>
</template>
<script>
import { DAYS, BEHAVIORS } from './data'
import { isArray, trim, findCheck, getKeyOfData, clearTagOfData } from '@/common/js/utils'

import CategorySelect from './select/category'
import KeywordSelect from './select/keyword'
import ActionResult from './result/result'

import { getAwemeCategory, awemeInfoSearch, getAwemeCategoryTopAuthor, getAwemeSimilarSearch } from '@/api/toutiao.model'

// 所有子集
const getCheckId = (item, data) => {
  if (!isArray(item)) return []
  return item.reduce((ids, ret) => {
    const cat = findChild(data)
      .filter((m) => ret.id === m.id)
      .pop()
    ids.push(ret.id)
    if (ret.children) ids = ids.concat(getCheckId(ret.children, data))
    else if (cat && isArray(cat.children)) ids = ids.concat(getCheckId(cat.children, data))
    return ids
  }, [])
}
// 子集
const findChild = (data) => {
  return data.reduce((childs, ret) => {
    childs.push(ret)
    if (ret.children) childs = childs.concat(findChild(ret.children))
    return childs
  }, [])
}
export default {
  name: 'awemeAction',
  // ATreeSelect: TreeSelect,
  components: { CategorySelect, KeywordSelect, ActionResult },
  props: {
    value: {
      type: Array
    },
    accounts: {
      type: Array
    },
    behaviors: {
      type: Array
    },
    timescope: {
      type: String
    },
    max: {
      type: Number
    }
  },
  computed: {
    action_days: {
      get() {
        return this.timescope || 'FIFTEEN_DAYS'
      },
      set(val) {
        this.$emit('on-days', val)
      }
    },
    action_scene: {
      get() {
        return this.behaviors || []
      },
      set(val) {
        this.$emit('on-scene', val)
      }
    },
    sceneLen() {
      return this.action_scene.length
    },
    mult_category() {
      return findCheck(this.categories)
    },
    account() {
      const actIds = isArray(this.accounts) && this.accounts.map((ret) => ret.id)
      const accounts = actIds || [3232]
      return accounts.shift()
    },
    userAccount() {
      if (isArray(this.accounts) && this.accounts.length) {
        const { name } = this.accounts.filter((_) => 1).pop()
        return name
      } else return ''
    },
    actions() {
      const categoryActions = this.mult_category.map((ret) => Object.assign(ret, { type: 'CATEGORY', id: ret.key, name: ret.value }))
      const keywordActions = isArray(this.words) ? this.words.map((ret) => Object.assign(ret, { type: 'KEYWORD' })) : []
      return [...keywordActions, ...categoryActions]
    },
    disabled() {
      return this.actions.length >= this.max
    }
  },
  data() {
    return {
      loading: null, // 数据请求状态
      quering: null, // 请求关键词状态
      canning: null,
      author: '', // 相似拼音号
      queryWord: {}, // 选中类目
      recommons: [],
      words: [], // 已选关键词
      categories: [], // 类目数据
      completeData: [], // 关键词下拉模糊搜索数据源
      keywords: [], // 关键词数据
      autoData: [], // 类目下拉数据源
      tagType: 'category',
      days: DAYS,
      cascaderOptions: BEHAVIORS
    }
  },
  methods: {
    searchKeyword(query) {
      if (this.tagType !== 'keyword') this.tagType = 'keyword'
      this.queryWord = getKeyOfData(this.categories, 'key', query)
      this.quering = true
      getAwemeCategoryTopAuthor({
        ad_account_id: this.account,
        behaviors: this.behaviors,
        categoryId: query
      }).then((data) => {
        if (typeof data !== 'symbol') {
          if (!isArray(data)) {
            this.quering = false
            return
          }
          this.recommons = []
          this.keywords = data.map((ret) => {
            return {
              id: ret.label_id,
              key: ret.label_id,
              name: ret.author_name,
              num: ret.total_fans_num_str,
              value: ret.author_name,
              type: 'KEYWORD',
              aweme: ret.aweme_id,
              avatar: ret.avatar
            }
          })
          this.quering = false
        }
      })
    },
    // 找相似
    queryKeyword(meta) {
      this.quering = true
      getAwemeSimilarSearch({
        ad_account_id: this.account,
        behaviors: this.behaviors,
        aweme_id: meta.aweme
      })
        .then((data) => {
          if (typeof data !== 'symbol') {
            if (!isArray(data)) {
              this.quering = false
              return
            }
            this.recommons = data.map((ret) => {
              return {
                id: ret.label_id,
                key: ret.label_id,
                name: ret.author_name,
                num: ret.total_fans_num_str,
                value: ret.author_name,
                type: 'KEYWORD',
                aweme: ret.aweme_id,
                avatar: ret.avatar
              }
            })
            this.author = meta.name
            this.quering = false
          }
        })
        .catch(() => {
          this.quering = false
        })
    },
    // 下拉数据
    searchCategory(query) {
      this.autoData = []
      this.canning = true
      awemeInfoSearch({
        ad_account_id: this.account,
        behaviors: this.behaviors,
        queryWord: trim(query)
      })
        .then((data) => {
          if (typeof data !== 'symbol') {
            if (isArray(data) && data.length && this.canning) {
              const { authors, categories } = data.pop()
              if (isArray(categories) && categories.length) {
                const childCategories = (ret) => {
                  if (!isArray(ret.children) || !ret.children.length) {
                    return {
                      id: ret.id,
                      name: ret.value,
                      key: ret.id,
                      value: ret.id,
                      type: 'CATEGORY',
                      num: ret.fans_num_str
                    }
                  } else {
                    const [child] = ret.children
                    return childCategories(child)
                  }
                }
                this.autoData.push({
                  id: 1,
                  name: '达人分类',
                  children: categories.map((ret) => childCategories(ret))
                })
              }
              if (isArray(authors) && authors.length) {
                this.autoData.push({
                  id: 2,
                  name: '抖音达人',
                  children: authors.map((ret) => {
                    return {
                      id: ret.label_id,
                      name: ret.author_name,
                      key: ret.label_id,
                      num: ret.total_fans_num_str,
                      value: ret.author_name,
                      type: 'KEYWORD',
                      aweme: ret.aweme_id,
                      avatar: ret.avatar
                    }
                  })
                })
              }
              this.canning = false
            } else this.canning = false
          }
        })
        .catch(() => {
          this.canning = false
        })
    },
    // 批量加入关键词
    selectKeyword(items) {
      if (!isArray(items)) return
      const invaild = this.max - this.actions.length
      const word_ids = this.words.map((ret) => ret.id)
      const push_items = items
        .filter((ret, id) => id < invaild && !word_ids.includes(ret.id))
        .map((ret) => Object.assign(ret, { _time: Date.now() }))
      this.words.push(...push_items)
    },
    cannelHandle() {
      this.canning && (this.canning = false)
      this.autoData = []
    },
    // 删除已选
    delTag(item) {
      const { id, type } = item
      if (type === 'CATEGORY') {
        const data = getKeyOfData(this.categories, 'key', id)
        const delCheck = (item) => {
          if (item.children && item.children.length) {
            item.children.forEach((ret) => {
              delCheck(ret)
            })
          }
          this.$set(item, 'check', false)
        }
        delCheck(data)
      } else {
        const idx = this.words.findIndex((ret) => ret.id === id)
        if (idx > -1) this.words.splice(idx, 1)
      }
    },
    // 清空全部
    clearTag() {
      clearTagOfData(this.categories, this)
      this.words = []
    },
    proLoadData() {
      getAwemeCategory({
        ad_account_id: this.account,
        behaviors: this.behaviors
      }).then((data) => {
        this.loading = true
        if (isArray(data)) {
          const defaultActions = isArray(this.value) && this.value.filter((ret) => ret.type.toLowerCase() === 'category') // 类目已选
          const defaultWords = isArray(this.value) && this.value.filter((ret) => ret.type.toLowerCase() === 'keyword') // 关键词
          const defaultActionIds = getCheckId(defaultActions, data) // 类目id
          const mapCategroy = (ret) => {
            // 初始化数据
            const checkState = defaultActionIds.includes(ret.id)
            const cate = {
              id: ret.id,
              key: ret.id,
              value: ret.value,
              name: ret.value,
              check: checkState,
              num: ret.fans_num_str,
              type: 'CATEGORY',
              _time: ret._time
            }
            if (ret.children) return Object.assign({}, cate, { children: ret.children.map(mapCategroy) })
            else return cate
          }
          const mapComplete = (ret) => {
            const cate = {
              title: ret.value,
              key: ret.id,
              value: ret.id,
              type: 'CATEGORY',
              num: ret.fans_num_str
            }
            if (ret.children) return Object.assign({}, cate, { children: ret.children.map(mapComplete) })
            else return cate
          }
          this.categories = data.map(mapCategroy) // 还原选中值
          this.completeData = data.map(mapComplete)
          this.words = defaultWords
        }
      })
    }
  },
  watch: {
    actions: {
      handler(nVal) {
        this.$emit('input', nVal)
      },
      deep: true
    },
    behaviors: {
      handler() {
        this.loading = false
        this.proLoadData()
      },
      deep: true
    }
  },
  created() {
    this.proLoadData()
  }
}
</script>
<style lang="scss" scoped>
.c-aweme-action {
  position: relative;

  .c-aweme-line {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .scene-error {
      position: absolute;
      top: 34px;
      left: 113px;
    }
  }

  .c-action-content {
    .c-action-category {
      border: solid 1px #dee4f5;

      ::v-deep .c-tabs-content {
        padding: 0 8px 10px 8px;
      }

      ::v-deep .c-action-search {
        margin-bottom: 16px;
      }
    }
  }

  ::v-deep .ivu-tabs-bar {
    margin-bottom: 12px !important;
  }

  ::v-deep .el-input {
    .el-input__inner,
    .el-input__icon {
      height: 30px;
      line-height: 30px;
    }
  }

  ::v-deep .ivu-tabs-nav {
    margin-left: 10px;

    .ivu-tabs-tab {
      padding: 15px 16px;
    }
  }
}
</style>
